(function() {
	
	const wrapperClass = 'embed-player';
	
	const _doWrap = () => {
		const ytPlayers = Array.from( document.querySelectorAll("iframe[src*='youtube.com']") );
		ytPlayers.forEach(player => {
			if( player.parentNode.parentNode.classList.contains(wrapperClass) ) {
				return;
			}
			
			const cloned = player.cloneNode();
			const playerWrap = document.createElement('span');
			playerWrap.classList.add(wrapperClass);
			
			const playerInner = document.createElement('span');
			playerInner.classList.add('embed-player--inner');
			playerInner.appendChild(cloned);
			playerWrap.appendChild(playerInner);
			
			const attrW = player.getAttribute('width');
			const attrH = player.getAttribute('height');
			if(! isNaN(attrW) && ! isNaN(attrH) ) {
				const ratio = parseInt(attrW, 10) / parseInt(attrH, 10);
				const fmtClass = ratio === 1 ? 'ep-square' : (ratio > 1 ? 'ep-landscape' : 'ep-portrait');
				playerWrap.classList.add(fmtClass);
				playerInner.style.width = '100%';
				playerInner.style.paddingTop = (100 / ratio) + '%';
			}
			
			player.parentNode.replaceChild(playerWrap, player);
		});
	};
	
	_doWrap();
	document.addEventListener('pageLoad', () => _doWrap() );
})();